import { Injectable } from '@angular/core';
import { Router, CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {UserStorage} from '../core/storage/user.storage';
import {UserService} from '../core';
import {OauthService} from '../core/services/oauth.service';
import {CONFIG} from '../core/config/application.config';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
    constructor(
        private router: Router,
        private userStorage: UserStorage,
        private userService: UserService,
        private oauthService: OauthService,
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
        let isLoginPage = state.url.startsWith("/login");
        if (!isLoginPage) {
            this.userStorage.setNextUrl(state.url);
        }
        if (this.userStorage.checkExistsIsLogin()) {
            if (isLoginPage) {
                this.router.navigate(['/layout/timemanagement/presencemanagement']);
            } else if (this.userService.tokenExpired()) {
                this.oauthService.doRefreshToken().subscribe(result => {
                    this.userStorage.setRefreshToken(result.refresh_token);
                    this.userStorage.setAccessToken(result.access_token);
                    this.userStorage.setAccessTokenExpiredTime(result.expires_in);
                    localStorage.setItem(CONFIG.token_get_time, Date.now() + '');
                }, error => {
                    this.userStorage.logoutByDeleteAll();
                    this.router.navigate(['/login']);
                })
            }
            return true;
        }

        if (!isLoginPage) {
            this.router.navigate(['/login']);
        }
        return true;
    }
}
